import coreStore from './core-store'

const remoteResource = 'party/api/v1/party-role-types';

export default coreStore.createCoreStore('partyRoleType', remoteResource);